import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateNavReconRiskDataMeta } from '../nav-recon.routes';
import {
  NavReconPipelineMetadata,
  UpdateNavReconRiskDataMetaPayload,
} from '../types';

export const useUpdateNavReconRiskDataMeta = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateNavReconRiskDataMeta,
    onSuccess: (_, variables: UpdateNavReconRiskDataMetaPayload) => {
      const queryKey = ['nav-recon-pipeline-metadata', variables.position_date];

      queryClient.setQueryData<NavReconPipelineMetadata[]>(
        [queryKey],
        (current) =>
          current?.map((fund) => {
            if (fund.fund_name !== variables.fund_name) return fund;

            return {
              ...fund,
              stages: fund.stages.map((stage) => {
                if (stage.rs_data_name !== variables.rs_data_name) {
                  return stage;
                }

                return {
                  ...stage,
                  snapshots: stage.snapshots.map((snapshot) =>
                    snapshot.snapshot_timestamp === variables.snapshot_timestamp
                      ? {
                          ...snapshot,
                          client_audit_status: variables.client_audit_status,
                          client_comment: variables.client_comment,
                        }
                      : snapshot,
                  ),
                };
              }),
            };
          }),
      );

      queryClient.invalidateQueries({ queryKey });
    },
  });
};
